define([
    'app/models/delivery',
    'app/models/order',
    'app/models/klarnaOrder',
    'app/models/cartItem',
    'app/models/product',
    'app/helpers/helpers',
    'app/messages/cartMessages',
], function (Delivery, Order, KlarnaOrder, CartItem, Product, Helper, CartMessages) {
    function ShoppingCart() {
        var privates = {};
        var publics = {};

        const cartMessages = new CartMessages();

        publics.events = {};
        publics.items = {};
        publics.totals = {};
        publics.displayTotals = {};
        publics.productsInCart = false;
        publics.delivery = false;
        publics.loaded = false;
        publics.data = {};
        publics.cartId = false;

        privates.allProductsFromHashedCart = []; // contains the products we expect to load with hashed cart
        privates.expectedNumberOfProductsFromHash = 0; // used to determine wether we have loaded all products

        publics.discountCodeToAdd = '';
        publics.showDiscountField = false;
        publics.activeDiscount = false;
        publics.activeGiftCard = false;
        publics.retailerPrices = false;

        publics.serverValidate = true;

        publics.showMiniCart = false;

        privates.discountPollInProgress = false;
        privates.addingAutoProduct = false;

        publics.getDefaultFreeShippingLimits = function (country) {
            //it is unclear if this function ever gets used but we keep it for now
            const freeShippingLimits = {
                SE: 600,
                NO: 99999999,
                FI: 99999999,
                DK: 500,
            };
            return freeShippingLimits[country];
        };

        publics.freeShippingLimit = publics.getDefaultFreeShippingLimits(partyking.config.country);

        publics.totalTowardsFreeShipping = 0;
        publics.discountedTotalTowardsFreeShipping = 0;

        publics.displayFreeShipping = false;

        publics.max_delivery_days = 1;
        publics.min_delivery_days = 3;
        publics.isQuantityInStock = true;
        publics.deliverytext = '';

        publics.orderSent = false;
        publics.hash = '';
        publics.showHash = false;
        publics.ignoreStock = false;
        publics.isPerformingCheckoutValidation = false;

        privates.precision = partyking.config.currency.precision;
        privates.klarnaPrecision = 2;

        publics.init = function () {
            privates.loadFromCache();

            if (!_.isEmpty(publics.data) && !_.isEmpty(publics.data.delivery_methods)) {
                privates.initClasses();
                privates.setEvents();
                publics.trigger('loaded', publics);
                publics.loaded = true;
            } else {
                publics.update();

                privates.loadShoppingcart(function () {
                    privates.initClasses();
                    privates.setEvents();
                    publics.loaded = true;
                });
            }
        };

        privates.loadShoppingcart = function (cb) {
            $.get(partyking.config.checkout_json_url, {}, function (data) {
                publics.data = data;

                if (_.isFunction(cb)) {
                    cb();
                }
            });
        };

        privates.initClasses = function () {
            publics.delivery = new Delivery(publics.data.delivery_methods);
            publics.update();
        };

        privates.setEvents = function () {
            publics.delivery.on('update', function () {
                publics.update();
            });

            partyking.common.models.pkStorage.on('update', function () {
                privates.loadFromCache();
                publics.update(true);
            });
        };

        publics.update = function (noCaching) {
            /*
          this prevents ractive from bugging in some cases,
          something to do with magic variables
          */
            publics.items = publics.items;

            if (privates.isInCheckout()) {
                publics.handleFreeCrapInCheckout(publics.items);
            }

            const freeProduct = privates.getFreeProduct();
            if (freeProduct && freeProduct.quantity > 1) {
                freeProduct.setQuantity(1);
                cartMessages.onlyOneFreeCrapAllowed();
            }

            privates.handleItemPopups(publics.items);
            privates.deleteItemsWithZeroQuantity();
            privates.updateDiscounts();
            privates.updateShipping();
            privates.updateGiftcard();
            privates.updateTotals();
            privates.updateNumberOfproductsInCart();
            privates.updateCartShippingTime();

            if (publics.showHash) {
                publics.showHash = false;
            }

            if (!publics.cartId) {
                publics.cartId = Helper.uuid();
            }

            if (!noCaching) {
                publics.cacheCart();
            }

            publics.trigger('update', publics);
            // Make ractive aware of changes
            publics.items = publics.items;
        };

        // Free crap
        publics.handleFreeCrapInCheckout = function () {
            if (publics.isFreeCrapTheOnlyProduct()) {
                privates.removeFreeProductsFromCart();
                cartMessages.onlyFreeCrapNotAllowedInCheckout();
            }
        };

        privates.isInCheckout = function () {
            return window.location.pathname === partyking.pages.CHECKOUT.html;
        };

        privates.shouldAddProduct = function (product, items) {
            if (privates.isProductFreeCrap(product)) {
                if (privates.hasFreeProductsInCart(items)) {
                    return false;
                }
            }
            return true;
        };

        privates.freeProducts = ['16354-1', '107029-1'];

        privates.getFreeProduct = function () {
            privates.freeProducts.forEach((artNum) => {
                if (publics.items[artNum] !== 'undefined') {
                    return publics.items[artNum];
                }
            });

            return null;
        };

        privates.removeFreeProductsFromCart = function () {
            privates.freeProducts.forEach((artNum) => {
                if (publics.items[artNum] !== 'undefined') {
                    delete publics.items[artNum];
                }
            });
        };

        privates.hasFreeProductsInCart = function (items) {
            return privates.freeProducts.some((artNum) => items[artNum] !== undefined);
        };

        privates.isProductFreeCrap = function (product) {
            return this.freeProducts.some((artNum) => product.key == artNum);
        };

        publics.isFreeCrapTheOnlyProduct = function () {
            const productCount = publics.getAllProducts().length;
            if (productCount > 1 || productCount == 0) {
                return false;
            }

            return privates.hasFreeProductsInCart(publics.items);
        };

        // End free crap

        privates.updateShipping = function () {
            if (publics.delivery) {
                publics.items['shipping'] = publics.delivery.getCartItem();
            }
        };

        publics.getFreeShippingLimit = function () {
            if (publics.retailer || ['fi_FI.UTF8', 'nb_NO.UTF8'].includes(partyking.config.locale)) {
                return 99999999;
            }
            return publics.freeShippingLimit;
        };

        privates.isZeroOrder = function () {
            var calculatedTotals = privates.totals();
            var total = calculatedTotals.totals.total;

            if (total === 0) {
                return true;
            }

            return false;
        };

        privates.updateGiftcard = function () {
            publics.items['giftcard'] = undefined;
            delete publics.items['giftcard'];

            var calculatedTotals = privates.totals();
            total = calculatedTotals.totals.total;

            if (publics.activeGiftCard) {
                amount = false;

                giftCardValue = Math.abs(partyking.common.helpers.value_price(publics.activeGiftCard.amount));

                if (giftCardValue > total) {
                    giftCardValue = total;
                }

                if (giftCardValue && giftCardValue > 0) {
                    amount = _.clone(partyking.config.currency);
                    amount.vat = 25;

                    // gör om till ören   ta bort momsen på vat%
                    amount.value = (-100 * giftCardValue) / (1 + amount.vat / 100);

                    publics.items['giftcard'] = new CartItem(
                        {
                            price: amount,
                            itemid: publics.activeGiftCard.itemid,
                        },
                        1,
                        'giftcard'
                    );

                    publics.items['giftcard'].leftOnGiftcard =
                        Math.abs(partyking.common.helpers.value_price(publics.activeGiftCard.amount)) - giftCardValue;
                }
            }
        };

        privates.calculateDiscountedTowardsFreeShipping = function (discount, totalTowardsFreeShipping) {
            if (discount?.percent) {
                return totalTowardsFreeShipping * ((100 - discount.percent) / 100);
            } else if (discount?.amount?.value) {
                const discountAmount = (discount.amount.value * (1 + discount.amount.vat / 100)) / 100; // Transform the vat to a positive multiplier
                return totalTowardsFreeShipping + discountAmount; // We add the discount because the value is negative
            }
            return totalTowardsFreeShipping;
        };

        privates.isShippingFree = function () {
            var activeDiscount = publics.getActiveDiscount();

            if (activeDiscount && activeDiscount.freeshipping) {
                publics.displayFreeShipping = true; // Used by progressbar
                return true;
            }

            privates.updateFreeShippingLimit();
            var calculatedTotals = privates.totals();
            publics.totalTowardsFreeShipping = calculatedTotals.totals.subTotal;

            // Logic for calculating if we should show the progressbar or not
            publics.discountedTotalTowardsFreeShipping = privates.calculateDiscountedTowardsFreeShipping(
                activeDiscount,
                publics.totalTowardsFreeShipping
            );
            publics.displayFreeShipping = publics.discountedTotalTowardsFreeShipping >= publics.getFreeShippingLimit();

            if (publics.totalTowardsFreeShipping >= publics.getFreeShippingLimit()) {
                return true;
            }

            return false;
        };

        privates.updateFreeShippingLimit = function () {
            if (!publics.delivery) return false;

            var activeDeliveryMethod = publics.delivery.getActiveDeliverMethod();

            if (parseInt(activeDeliveryMethod.freeShippingLimit) > 0) {
                publics.freeShippingLimit = parseInt(activeDeliveryMethod.freeShippingLimit);
            } else {
                publics.freeShippingLimit = publics.getDefaultFreeShippingLimits(partyking.config.country);
            }
        };

        privates.updateDiscounts = function () {
            publics.items['discount'] = undefined;
            delete publics.items['discount'];

            // free shipping calculations
            publics.delivery.isFreeShipping = privates.isShippingFree();
            privates.updateShipping();

            var calculatedTotals = privates.totals(publics.activeDiscount.validproducts);
            var subTotal = calculatedTotals.totals.subTotal;
            var percent = 0;

            var activeDiscount = publics.getActiveDiscount();

            if (publics.getActiveDiscount()) {
                percent = parseInt(publics.activeDiscount.percent) || 0;

                if (publics.activeDiscount.amount.value) {
                    discount = Math.abs(partyking.common.helpers.value_price(publics.activeDiscount.amount));

                    percent = partyking.common.helpers.round(100 * (discount / subTotal), privates.klarnaPrecision);

                    if (percent > 100) {
                        percent = 100;
                    }
                }

                if (percent > 0) {
                    discountValue = _.reduce(
                        publics.items,
                        function (memo, item) {
                            item.update();

                            var validproducts = publics.activeDiscount.validproducts;

                            if (item.type == 'product' && (!validproducts || validproducts.indexOf(item.key) !== -1)) {
                                memo += partyking.common.helpers.round(item.totals.total * (percent / 100), 2);
                            }

                            return memo;
                        },
                        0
                    );

                    if (discountValue > 0) {
                        var amount = _.clone(partyking.config.currency);
                        amount.vat = 25;
                        amount.precision = privates.klarnaPrecision;

                        // gör om till ören ta bort momsen på vat%
                        amount.value = (-100 * discountValue) / (1 + amount.vat / 100);

                        publics.items['discount'] = new CartItem(
                            {
                                price: amount,
                                itemid: publics.activeDiscount.itemid,
                            },
                            1,
                            'discount'
                        );
                    } else if (!(activeDiscount && (activeDiscount.freeshipping || activeDiscount.ignoreStock))) {
                        partyking.common.models.messages.warning(
                            'inline',
                            partyking.common.helpers.l.translate('Varukorgen uppfyller inte kraven för rabattkoden')
                        );
                        publics.removeDiscountCode();
                    }
                } else if (!(activeDiscount && (activeDiscount.freeshipping || activeDiscount.ignoreStock))) {
                    partyking.common.models.messages.warning(
                        'inline',
                        partyking.common.helpers.l.translate('Varukorgen uppfyller inte kraven för rabattkoden')
                    );
                    publics.removeDiscountCode();
                }
            }
        };

        privates.updateNumberOfproductsInCart = function () {
            publics.productsInCart = publics.numberOfproductsInCart();
        };

        publics.numberOfproductsInCart = function () {
            return _.reduce(
                publics.items,
                function (memo, item) {
                    return memo + (item.type == 'product' ? item.quantity : 0);
                },
                0
            );
        };

        publics.markOrderSent = function () {
            publics.orderSent = true;
            publics.cacheCart();
        };

        publics.unMarkOrderSent = function () {
            publics.orderSent = false;
            publics.cacheCart();
        };

        privates.loadFromCache = function () {
            var cache = partyking.common.models.pkStorage.get('shoppingcart');

            if (_.isObject(cache)) {
                publics.serverValidate = cache.serverValidate;
                publics.retailerPrices = cache.retailerPrices;
                publics.activeDiscount = cache.activeDiscount;
                publics.activeGiftCard = cache.activeGiftCard;
                publics.showDiscountField = cache.showDiscountField;
                publics.ignoreStock = cache.ignoreStock;
                publics.orderSent = cache.orderSent;
                publics.data = cache.data;
                publics.cartId = cache.cartId || false;

                cache = publics.cacheToCart(cache);

                publics.items = cache.items;

                return true;
            }

            return false;
        };

        publics.cacheCart = function () {
            partyking.common.models.pkStorage.set('shoppingcart', publics.cartToCache());
        };

        publics.getMaxVAT = function () {
            var vat = 0;
            $.each(publics.items, function (i, item) {
                if (item.type == 'product' && item.vatPercent > vat) {
                    vat = item.vatPercent;
                }
            });
            return vat;
        };

        publics.cartToCache = function () {
            var cache = {};

            cache.items = _.mapObject(publics.items, function (item) {
                var output = {
                    quantity: item.quantity,
                    data: item.data,
                    name: item.name,
                    type: item.type,
                    description: item.description,
                    productPicture: item.productPicture,
                    url: item.url,
                };

                //if(item.print){
                //  output.print = item.print
                //}

                return output;
            });

            cache.serverValidate = publics.serverValidate;
            cache.retailerPrices = publics.retailerPrices;
            cache.activeDiscount = publics.activeDiscount;
            cache.activeGiftCard = publics.activeGiftCard;
            cache.showDiscountField = publics.showDiscountField;
            cache.orderSent = publics.orderSent;
            cache.data = publics.data;
            cache.ignoreStock = publics.ignoreStock;
            cache.cartId = publics.cartId;

            return cache;
        };

        publics.cacheToCart = function (cache) {
            cache.items = _.mapObject(cache.items, function (c) {
                /*if(c.print){
              c.data.print = c.print
            }*/

                var item = new CartItem($.extend({}, c.data), c.quantity, c.type);

                item.name = c.name;
                item.description = c.description;
                item.productPicture = c.productPicture;
                item.url = c.url;
                return item;
            });

            return cache;
        };

        publics.isCartEmpty = function () {
            return publics.numberOfproductsInCart() === 0;
        };

        publics.isPreorder = function () {
            return !publics.isQuantityInStock;
        };

        publics.getItemKey = function (item) {
            return item.data.productid + '-' + item.data.id;
        };

        publics.addProductToProductsFromHashedCart = function (product) {
            privates.allProductsFromHashedCart.push(product);
            if (privates.allProductsFromHashedCart.length == privates.expectedNumberOfProductsFromHash) {
                publics.trigger('allProductsFetched', publics);
                privates.setExpectedNumberOfProductsFromHash(0);
            }
        };

        publics.addItem = function (cartItem, quantity, source = 'product', restrict = false) {
            var key = cartItem.getItemKey();

            let initialQuantity = 0;
            let wasRestricted = restrict;

            if (!privates.shouldAddProduct(cartItem, publics.items)) {
                if (privates.isProductFreeCrap(cartItem)) {
                    cartMessages.onlyOneFreeCrapAllowed();
                }
                return;
            }

            var q = parseInt(quantity) || 1;
            cartItem.setQuantity(q);

            if (_.isObject(publics.items[key])) {
                initialQuantity = publics.items[key].quantity;

                publics.items[key].increaseQuantity(q);
            } else {
                publics.items[key.toString()] = cartItem;

                if (cartItem.type == 'product') {
                    publics.trigger('newProductAdded', cartItem);
                }
            }

            if (publics.items[key].quantity < 1) {
                publics.deleteItem(cartItem);
            }

            publics.update();

            if (publics.items[key].quantity == initialQuantity) {
                wasRestricted = true;
            }

            const body = document.querySelector('body');
            const isCheckout = body.classList.contains('checkout');

            if (isCheckout) {
                wasRestricted = true;
            }

            if (cartItem.type == 'product') {
                partyking.common.trigger('productAdded', {
                    cartItem: cartItem,
                    quantity: q,
                    restricted: wasRestricted,
                    source,
                });
            }
        };

        publics.removeItem = function (cartItem) {
            var key = cartItem.getItemKey();
            if (!_.isObject(publics.items[key])) return;
            publics.items[key].decreaseQuantity();
            if (publics.items[key].quantity < 1) {
                if (
                    privates.isInCheckout() &&
                    publics.getAllProducts().length === 2 &&
                    privates.hasFreeProductsInCart(publics.items) &&
                    !privates.isProductFreeCrap(cartItem)
                ) {
                    publics.items[key].increaseQuantity();
                    return cartMessages.removeLastItemLeavingOnlyFreeCrap(() => {
                        publics.items[key].decreaseQuantity();
                        publics.deleteItem(cartItem);
                    });
                }

                publics.deleteItem(cartItem);
            }

            publics.update();

            if (cartItem.type == 'product') {
                partyking.common.trigger('productRemoved', {
                    cartItem: cartItem,
                    quantity: -1,
                });
            }
        };

        publics.productIdsAsString = function () {
            return publics
                .getAllProducts()
                .map((product) => product.data.productid)
                .join(',');
        };

        privates.getNameOfDay = function (number) {
            var weekday = new Array(7);
            weekday[0] = partyking.common.helpers.l.translate('söndag');
            weekday[1] = partyking.common.helpers.l.translate('måndag');
            weekday[2] = partyking.common.helpers.l.translate('tisdag');
            weekday[3] = partyking.common.helpers.l.translate('onsdag');
            weekday[4] = partyking.common.helpers.l.translate('torsdag');
            weekday[5] = partyking.common.helpers.l.translate('fredag');
            weekday[6] = partyking.common.helpers.l.translate('lördag');

            return weekday[number];
        };

        privates.updateCartShippingTime = function () {
            publics.max_delivery_days = 3;
            publics.min_delivery_days = 1;
            publics.isQuantityInStock = true;
            publics.deliverytext = '';

            $.each(publics.items, function (key, item) {
                if (publics.items[key].type == 'product') {
                    if (publics.items[key].stock.isQuantityInStock) {
                        if (publics.max_delivery_days < publics.items[key].data.max_deliver_days) {
                            publics.max_delivery_days = publics.items[key].data.max_deliver_days;
                        }

                        if (publics.min_delivery_days < publics.items[key].data.min_delivery_days) {
                            publics.min_delivery_days = publics.items[key].data.min_delivery_days;
                        }
                    } else {
                        publics.isQuantityInStock = false;

                        if (publics.max_delivery_days < publics.items[key].data.max_delivery_days_nonstock) {
                            publics.max_delivery_days = publics.items[key].data.max_delivery_days_nonstock;
                        }

                        if (publics.min_delivery_days < publics.items[key].data.min_delivery_days_nonstock) {
                            publics.min_delivery_days = publics.items[key].data.min_delivery_days_nonstock;
                        }
                    }
                }
            });

            if (publics.isQuantityInStock) {
                var secondsUntilDelivery = Math.round(
                    Math.abs(new Date(partyking.config.next_delivery) - new Date()) / 1000
                );
                var next_delivery_time = new Date(partyking.config.next_delivery);

                if (secondsUntilDelivery < 36 * partyking.config.delivery_deadline) {
                    publics.deliverytext = partyking.common.helpers.l.translate(
                        'Din order kommer att skickas från oss idag'
                    );
                } else if (
                    secondsUntilDelivery > 36 * partyking.config.delivery_deadline &&
                    secondsUntilDelivery < 3600 * 24
                ) {
                    publics.deliverytext = partyking.common.helpers.l.translate(
                        'Din order kommer att skickas från oss i morgon'
                    );
                } else {
                    publics.deliverytext =
                        partyking.common.helpers.l.translate('Din order kommer att skickas från oss på ') +
                        ' ' +
                        privates.getNameOfDay(next_delivery_time.getDay());
                }
            }

            //Some delivery methods are dependant on isQuantityInStock
            if (publics.delivery && publics.delivery.update) {
                publics.delivery.update();
            }
        };

        privates.handleItemPopups = function (items) {
            try {
                const itemsOutsOfStock = privates.filterProductsOutOfStock(items);
                const productNamesOutOfStock = privates.filterAndJoinProductNames(
                    itemsOutsOfStock,
                    (p) => !p.wasUpdated
                );
                if (privates.expectedNumberOfProductsFromHash === 0) {
                    // If we dont check this we will overwrite the popup that checks if we loaded all items to cart
                    if (productNamesOutOfStock.length) {
                        const urlParams = new URLSearchParams(window.location.search);
                        if (urlParams.get('outofstock_on_payment')) {
                            return cartMessages.overStockOnPaymentWarning(productNamesOutOfStock);
                        }
                        return cartMessages.overStockWarning(productNamesOutOfStock);
                    }

                    const produtNamesOutOfStockQtyIncreased = privates.filterAndJoinProductNames(
                        itemsOutsOfStock,
                        (p) => p.wasUpdated
                    );

                    if (produtNamesOutOfStockQtyIncreased.length) cartMessages.overStockQuntityIncreasedWarning();
                }
            } catch (error) {
                console.error(error);
            }
        };

        privates.filterProductsOutOfStock = (items) =>
            Object.values(items).reduce((acc, item) => {
                if (item.type == 'product') {
                    const checkedQuantity = item.checkQuantityAndStock();
                    if (!checkedQuantity.isInstock)
                        acc.push({
                            ...checkedQuantity,
                            name: item.data.alternative ? `${item.name}(${item.data.alternative})` : item.name,
                        });
                }
                return acc;
            }, []);

        privates.filterAndJoinProductNames = (itemsArr, predicate) =>
            itemsArr
                .filter((p) => predicate(p))
                .map((p) => p.name)
                .join(', ');

        privates.deleteItemsWithZeroQuantity = function () {
            $.each(publics.items, function (key, item) {
                if (publics.items[key].type == 'product') {
                    if (publics.items[key].quantity < 1) {
                        publics.deleteItem(publics.items[key]);
                    }
                }
            });
        };

        publics.deleteItem = function (cartItem) {
            var key = cartItem.key;
            publics.items[key] = undefined;
            delete publics.items[key];
            publics.items = publics.items;
            publics.update();
        };

        privates.updateTotals = function () {
            var t = privates.totals();
            publics.totals = t.totals;
            publics.displayTotals = t.displayTotals;
        };

        publics.isProductByIdInCart = function (id) {
            return !!publics.getProductById(id);
        };

        publics.getProductById = function (id) {
            var el = _.find(publics.getProducts(), function (item) {
                return item.data.belongs_to_product.id == id;
            });

            return _.isUndefined(el) ? false : el;
        };

        publics.getProduct = function (urlname) {
            var el = _.find(publics.getProducts(), function (item) {
                return item.data.belongs_to_product.urlname == urlname;
            });

            return _.isUndefined(el) ? false : el;
        };

        publics.isProductInCart = function (urlname) {
            return !!publics.getProduct(urlname);
        };

        publics.getProducts = function () {
            return _.filter(publics.items, function (item) {
                return item.type == 'product';
            });
        };

        publics.getMaxWeight = function () {
            var products = publics.getProducts();
            var heaviest = _.max(products, function (item) {
                return item.data.weight;
            });

            if (heaviest) {
                return heaviest.data.weight || 0;
            }

            return 0;
        };

        publics.reloadOrder = function (url) {
            // var url = "/orders/" + id + "/" + mailKey + "/reload.json";

            $.get(url, function (data) {
                if (!data.error) {
                    partyking.common.models.pkStorage.loadFromString(data.local_storage);

                    setTimeout(function () {
                        window.location.href = partyking.pages.CHECKOUT.html;
                    }, 1000);
                } else {
                    partyking.common.models.messages.message('inline', data.message);
                }
            });
        };

        privates.totals = function (products_filter) {
            products_filter = Array.isArray(products_filter) ? products_filter : false;

            var displayPriceSettings = partyking.config.currency;

            var totals = _.reduce(
                publics.items,
                function (memo, item) {
                    item.update();

                    if (
                        item.type == 'product' &&
                        Array.isArray(products_filter) &&
                        products_filter.indexOf(item.key) === -1
                    ) {
                        return memo;
                    }

                    switch (item.type) {
                        case 'shipping':
                            memo.shipping += item.totals.total;
                            memo.shippingNoVat += item.totals.totalNoVat;
                            break;
                        case 'discount':
                            memo.discount += item.totals.total;
                            break;
                        case 'giftcard':
                            memo.giftcard += item.totals.total;
                            memo.giftcardLeft += item.leftOnGiftcard;
                            break;
                        case 'product':
                            memo.subTotal += item.totals.total;
                            memo.subTotalNoVat += item.totals.totalNoVat;
                            break;
                    }

                    memo.totalNoVat += item.totals.totalNoVat;
                    memo.total += item.totals.total;

                    if (item.vatPercent > 0 && typeof memo['moms' + item.vatPercent.toString()] !== 'undefined') {
                        memo['moms' + item.vatPercent.toString()] += item.totals.totalVat;
                    }

                    return memo;
                },
                {
                    shipping: 0,
                    shippingNoVat: 0,
                    discount: 0,
                    giftcard: 0,
                    giftcardLeft: 0,
                    subTotal: 0,
                    totalNoVat: 0,
                    subTotalNoVat: 0,
                    moms6: 0,
                    moms12: 0,
                    moms25: 0,
                    total: 0,
                }
            );
            totals.subTotalNoShipping = totals.total - totals.shipping;
            // totals.total = parseInt(totals.total);

            if (parseInt(totals.total) < 0) {
                totals.total = 0;
            }

            var displayTotals = _.mapObject(totals, function (val) {
                var precision =
                    val.toFixed(privates.klarnaPrecision) != Math.ceil(val.toFixed(privates.klarnaPrecision))
                        ? privates.klarnaPrecision
                        : partyking.config.currency.precision; // visa alltid floats med signifikant decimal
                val.precision = precision;
                return partyking.common.helpers.display_price(val);
            });

            return {
                totals: totals,
                displayTotals: displayTotals,
            };
        };

        // sort the product in sortOrder
        privates.sortProducts = function () {
            if (publics.items.length) {
                publics.items.sort(function (a, b) {
                    return parseInt(a.sortOrder) - parseInt(b.sortOrder);
                });
            }
        };

        publics.getAllProducts = function () {
            return _.filter(publics.items, function (item) {
                return item.type == 'product';
            });
        };

        publics.isRetailer = function (code) {
            return (
                partyking.common.helpers.sha256(code || publics.retailerPrices || 'tomt') ==
                '3eed954b23e1bde8a11be01bf28ea8ceb41f208e177683e62a7199fbf8f106f6'
            );
        };

        publics.getActiveDiscount = function () {
            if (publics.activeDiscount) {
                if (publics.activeDiscount.min_total > 0) {
                    var calculatedTotals = privates.totals();
                    var thresholds = calculatedTotals.totals.subTotal + calculatedTotals.totals.shipping;

                    if (thresholds < publics.activeDiscount.min_total) {
                        return false;
                    }
                }

                return publics.activeDiscount;
            }

            return false;
        };

        publics.addDiscountCode = function (code, cb, silent) {
            publics.retailerPrices = false;

            if (code && !privates.discountPollInProgress) {
                discountPollInProgress = true; // prevent twitchy ppl from adding the code more than once

                $.get('/discounts/' + code, function (result) {
                    if (result.message == 'OK') {
                        if (result.type != 'giftcard') {
                            if (result.valid_for_productid) {
                                if (publics.isProductByIdInCart(result.valid_for_productid)) {
                                    console.log('product ', result.valid_for_productid, ' IS in cart');
                                } else {
                                    console.log('product not in cart!');
                                }
                            }

                            publics.activeDiscount = result;
                            publics.ignoreStock = result.ignoreStock || false;
                        } else {
                            publics.activeGiftCard = result;
                        }
                    } else {
                        if (!silent) {
                            partyking.common.models.messages.warning('inline', result.message);
                        }
                    }

                    privates.discountPollInProgress = false;
                    publics.update();

                    if (_.isFunction(cb)) {
                        cb(result.message === 'OK');
                    }
                });
            }
        };

        publics.removeDiscountCode = function () {
            publics.activeDiscount = false;
            publics.ignoreStock = false;
            partyking.config.currency.precision = privates.precision;

            publics.update();
        };

        publics.removeGiftCard = function () {
            publics.activeGiftCard = false;
            publics.update();
        };

        privates.createMissingProduct = (product, foundQuantity) => ({
            foundQuantity,
            expectedQuantity: product.getQuantity(),
            name: product.getName(),
            alternativeName: product.getAlternativeName(),
            artNum: product.getArtNum(),
            url: product.getUrl(),
        });

        publics.getMissingCartItems = () => {
            const tempProductsInCart = publics.getAllProducts();
            return privates.allProductsFromHashedCart.reduce((acc, compProduct) => {
                const productInCart = tempProductsInCart.find((product) => product.key === compProduct.getArtNum());

                if (!productInCart) acc.push(privates.createMissingProduct(compProduct, 0));
                else if (compProduct.getQuantity() !== productInCart.quantity) {
                    acc.push(privates.createMissingProduct(compProduct, productInCart.quantity));
                }
                return acc;
            }, []);
        };

        privates.setExpectedNumberOfProductsFromHash = function (length) {
            privates.expectedNumberOfProductsFromHash = length;
        };

        publics.hasProducts = () => publics.getAllProducts().length > 0;

        publics.createCartFromHash = function (hash, callback) {
            // Do magic.
            var jsonString = LZString.decompressFromEncodedURIComponent(hash);
            var cartItems = JSON.parse(jsonString);
            var tempDiscount = false;

            if (publics.activeDiscount) {
                tempDiscount = publics.activeDiscount;
            }
            // Clear our current cart if we have one
            publics.reset();

            if (tempDiscount) {
                publics.activeDiscount = tempDiscount;
            }

            // Add our items to our new shiny cart
            for (var i = 0, len = cartItems.length; i < len; i++) {
                var SKU = cartItems[i][0];
                var quantity = cartItems[i][1];
                var productId = SKU.split('-')[0];

                (function (quantity, productId, SKU) {
                    new Product(
                        false,
                        function (product) {
                            product.selectFromArtNr(SKU);
                            product.data.quantity = quantity;
                            product.addToCart();
                            product.addProductToProductsFromHashedCart(product);
                        },
                        '/' + productId + '.json'
                    );
                })(quantity, productId, SKU);
            }
            privates.setExpectedNumberOfProductsFromHash(cartItems.length);

            if (_.isFunction(callback)) {
                callback(true);
            } else {
                return 'OK';
            }
        };

        publics.createHashFromCart = function (callback) {
            // Convert cart items to json
            var cart_items = publics.getProducts();
            var hash = publics.createHash(cart_items);

            publics.hash = partyking.config.current_domain + '?cart=' + hash;

            if (_.isFunction(callback)) {
                callback(hash);
            } else {
                return hash;
            }
        };

        publics.createHash = function (items) {
            var cart_info = [];
            for (var i = 0, len = items.length; i < len; i++) {
                cart_info.push(new Array(items[i].key, items[i].quantity));
            }
            var jsonString = JSON.stringify(cart_info);
            hash = LZString.compressToEncodedURIComponent(jsonString);

            return hash;
        };

        publics.reset = function () {
            publics.items = {};
            publics.totals = {};
            publics.displayTotals = {};
            publics.productsInCart = false;
            publics.orderSent = false;
            publics.activeDiscount = false;
            publics.activeGiftCard = false;
            publics.cartId = false;
            publics.update();
        };

        publics.toOrder = function () {
            var items = privates.funcToObj(publics.items);
            var totals = {
                d: _.clone(publics.displayTotals),
                t: _.clone(publics.totals),
            };

            var delivery = publics.delivery.getActiveItemId();

            var discount = publics.getActiveDiscount();

            var giftcard = publics.activeGiftCard;

            return new Order(items, totals, delivery, discount, giftcard);
        };

        publics.toKlarnaOrder = function () {
            var items = privates.funcToObj(publics.items);

            var totals = {
                d: _.clone(publics.displayTotals),
                t: _.clone(publics.totals),
            };

            var delivery = publics.delivery.getActiveItemId();

            var discount = publics.getActiveDiscount();

            var giftcard = publics.activeGiftCard;

            var preOrder = publics.isPreorder();

            var deliveryDays = {
                min: publics.min_delivery_days,
                max: publics.max_delivery_days,
            };

            return new KlarnaOrder(items, totals, delivery, discount, giftcard, preOrder, deliveryDays);
        };

        privates.funcToObj = function (func) {
            return JSON.parse(JSON.stringify(func));
        };

        publics.on = function (event, cb) {
            publics.events[event] = publics.events[event] || [];
            publics.events[event].push(cb);

            if (event === 'loaded' && publics.loaded) {
                publics.trigger('loaded', publics);
            }
        };

        publics.trigger = function (event, data) {
            if (!publics.events[event]) {
                return false;
            }

            $.each(publics.events[event], function (key, cb) {
                if (_.isFunction(cb)) {
                    cb(data);
                }
            });
        };

        return publics;
    }

    return ShoppingCart;
});
